import React from 'react';
import { Link } from 'react-router-dom';
import P from '../../assets/Parasitic.png';

const ParasiticDraw = () => {
  return (
    <section className="bg-transparent text-white pt-16 pb-12 px-4 sm:px-6 relative z-10 min-h-screen flex items-center">
      {/* Ensuring the section takes full height and content is centered */}
      <div className="max-w-7xl mx-auto bg-gray-900 rounded-lg shadow-lg text-gray-900 p-6 sm:p-12">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
          
          {/* Parasitic Draw Information Section */}
          <div className="w-full lg:w-1/2 text-center lg:text-left">
            <h2 className="text-4xl sm:text-5xl font-bold text-cyan-500 mb-4 sm:mb-6">Parasitic Draw Diagnosis</h2>
            <p className="text-lg sm:text-2xl text-gray-300 mb-6 sm:mb-8">
              Is your battery draining too quickly? Parasitic draw might be the cause. We provide thorough diagnostics and repairs to stop the unwanted drain and restore your battery’s performance.
            </p>

            <h3 className="text-3xl sm:text-4xl font-semibold text-gray-200 mb-3 sm:mb-4">What is Parasitic Draw?</h3>
            <p className="text-base sm:text-xl text-gray-300 mb-4 sm:mb-6 leading-relaxed">
              Parasitic draw occurs when electrical components continue using power even when the car is off, leading to battery drain. Common causes include malfunctioning electronics or faulty wiring.
              <br /><br />
              Our skilled technicians quickly diagnose the source of the drain and perform necessary repairs to ensure your battery stays charged and your vehicle operates as it should.
            </p>

            <ul className="text-white list-disc pl-5 space-y-2 sm:space-y-3 text-base sm:text-xl">
              <li>Comprehensive diagnostics to identify the drain</li>
              <li>Repairs on faulty components causing power loss</li>
              <li>Restoration of battery life and performance</li>
              <li>Preventative measures to avoid future power issues</li>
            </ul>
          </div>

          {/* Image Section */}
          <div className="w-full lg:w-1/2 flex justify-center">
            <img
              src={P} // Replace with the owner's image path
              alt="Owner Profile"
              className="w-full sm:w-4/5 max-w-xs sm:max-w-md h-auto object-cover rounded-lg shadow-md"
            />
          </div>
        </div>

        {/* Button Section centered horizontally below the content */}
        <div className="flex justify-center mt-6">
          <Link to="/contact" className="py-3 sm:py-4 px-10 sm:px-16 bg-cyan-500 text-white font-bold rounded-full hover:bg-cyan-600 transition duration-300 text-lg sm:text-2xl">
            Contact Us
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ParasiticDraw;

